<template>
  <div class="centerBox">
    <div class="dataCenter centBoxIn">
      <div class="banner" id="banner">
        <div class="bannerIn">
          <span class="title">申请股宇宙数据库</span>
          <div class="downloadNow" @click="download" />
          <div class="countInfo">
            <div class="countItem" v-for="(item, index) in countList" :key="item.desc">
              <div class="countItemL">
                <img :src="require(`@/common/images/dataCenter/icon${index + 1}.png`)" />
              </div>
              <div class="countItemR">
                <div class="count">{{ item.count }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <introduceGYZ />
      <div class="info">
        <img alt class="dataCenterImg" id="dataCenterImg" src />
        <div class="downloadBtn downloadBtn1" id="downloadBtn1" @click="download" />
        <div class="downloadBtn downloadBtn2" id="downloadBtn2" @click="download" />
        <div class="downloadBtn downloadBtn3" id="downloadBtn3" @click="download" />
        <div class="downloadBtn downloadBtn4" id="downloadBtn4" @click="download" />
      </div>
    </div>
  </div>
</template>

<script>
import IntroduceGYZ from "@/components/IntroduceGYZ";
import { getContent } from "@/api/other";

export default {
  name: "dataCenter",
  components: { IntroduceGYZ },
  data() {
    return {
      countList: [
        { count: "600,000+", desc: "累计超算量" },
        { count: "86%+", desc: "模方成功率" },
        { count: "400,00+", desc: "数据解析次数" },
        { count: "100%+", desc: "数据覆盖量" },
      ],
    };
  },
  mounted() {
    this.setBannerImg();
  },
  methods: {
    download() {
      const link = document.createElement("a");
      link.href =
        "https://dexun-install-new.oss-cn-shenzhen.aliyuncs.com/GuyuzhouOfficial.exe";
      link.click();
    },
    setBannerImg() {
      const navList = JSON.parse(localStorage.getItem("navList"));
      if (!navList.length) return;
      let contentId;

      // 数据产品
      const navItem = navList.find((item) => item.path == "/dataCenter");
      let navChild;
      if (navItem.class.length) {
        contentId = navItem.class[0].id;
        navChild = navItem.class.find((item) => item.pictures);
      }
      const bannerImg = navItem.pictures || navChild.pictures;
      if (bannerImg) {
        document.querySelector("#banner").style.backgroundImage = `url(${bannerImg})`;
      }
      this.setInfoImg(contentId);
    },
    setInfoImg(id) {
      getContent(id).then((res) => {
        if (res.code == 200) {
          if (res.data[0].pictures) {
            document.querySelector("#dataCenterImg").src = res.data[0].pictures;
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.dataCenter {
  width: var(--content-max-width);
  min-width: 1200px;
}
.dataCenter .banner {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  height: 490px;
  background-size: contain;
}
.dataCenter .banner .bannerImg {
  width: 100%;
  min-height: 310px;
  visibility: hidden;
}
.dataCenter .banner .bannerIn {
  position: absolute;
  padding-left: 20px;

  width: var(--content-width);
  min-width: var(--content-min-width);
  margin-left: 50%;
  transform: translateX(-50%);
  height: 100%;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}
.dataCenter .banner .title {
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  display: inline-block;
  font-weight: 400;
  font-size: 83px;
  color: #ffffff;
  letter-spacing: 8px;
  text-shadow: 0px 3px 2px rgba(0, 9, 51, 0.16);
  text-align: left;
  width: 100%;
  text-transform: none;
}
.dataCenter .banner .downloadNow {
  cursor: pointer;
  margin-left: -32px;
  margin-top: 2.4%;
  width: 295px;
  height: 90px;
  background-color: none;
  background-image: url("../../common/images/dataCenter/downloadNow.png");
  background-position: center;
  background-size: cover;

  background-repeat: no-repeat;
}
.dataCenter .banner .downloadNow::after {
  content: "";
  display: none;
  cursor: pointer;
  width: 295px;
  height: 90px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../../common/images/dataCenter/downloadNow_active.png");
}
.dataCenter .banner .downloadNow:hover::after {
  display: block;
}
.dataCenter .banner .countInfo {
  position: absolute;
  width: 100%;
  height: 165px;
  top: 99%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-content: center;
  border-radius: 6px;
  color: #000000;
  background: linear-gradient(180deg, #b6c3e4 0%, #e3e6ee 100%);
}
.dataCenter .banner .countItem {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dataCenter .banner .countItem .countItemL {
  margin-right: 12px;
}
.dataCenter .banner .countItem .countItemL img {
  width: 64px;
  height: 64px;
}
.dataCenter .banner .countItem .countItemR {
  text-align: left;
}
.dataCenter .banner .countItem .count {
  font-weight: 600;
  line-height: 64px;
  font-size: 39px;
}
.dataCenter .banner .countItem .desc {
  font-weight: 500;
  font-size: 25px;
}

.dataCenter .info {
  position: relative;
  width: 100%;
}
.dataCenter .dataCenterImg {
  display: block;
  width: 100%;
}
.info .downloadBtn {
  position: absolute;
  cursor: pointer;
  width: 414px;
  height: 116px;
  background-image: url("../../common/images/dataCenter/download.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  z-index: 9;
}
.info .downloadBtn::after {
  content: "";
  display: none;
  position: absolute;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  width: 414px;
  height: 116px;
  background-image: url("../../common/images/dataCenter/download.png");
  background-repeat: no-repeat;
  z-index: 9;
}
.info .downloadBtn:hover::after,
.info .downloadBtn:active {
  display: block;
  z-index: 9;
  background-image: url("../../common/images/dataCenter/download_active.png");
  background-repeat: no-repeat;
}
.info .downloadBtn1 {
  top: 71.6%;
  left: 48.3%;
}
.info .downloadBtn2 {
  top: 80.2%;
  left: 19.2%;
}
.info .downloadBtn3 {
  top: 88.5%;
  left: 50.6%;
}
.info .downloadBtn4 {
  top: 96%;
  left: 19%;
}
</style>



// WEBPACK FOOTER //
// src/views/dataCenter/index.vue